import { BaseModal } from '../../modal/base/BaseModal';
import styled from '@emotion/styled';
import { TabGalleryImage } from '@model/common/image';
import { mq } from '@styles/breakpoints';
import React, { useMemo, useState } from 'react';
import { TestId } from '@components/test-ids';
import { Theme, ThemeProps } from '@theme/base';
import { withTheme } from '@emotion/react';
import {
  GalleryCloseButton,
  GalleryImageGrid,
  GalleryTabs,
  getFilteredImages,
  handleTabChangeWithScroll
} from './components';

const TabGalleryImageContainer = styled.div(({ theme }: ThemeProps) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  height: '100vh',
  width: '100vw',
  maxWidth: 1200,
  margin: '0 auto',
  alignItems: 'center',
  outline: 'none',
  transition: `max-width ${theme.custom.transitions.smooth}`,
  position: 'relative',
  padding: theme.custom.spacing.large,

  [mq.small]: {
    padding: theme.custom.spacing.medium
  }
}));

export interface TabGalleryImageModalProps {
  theme?: Theme;
  testId?: string;
  showGallery: boolean;
  galleryData: Array<TabGalleryImage>;
  onDismiss: () => void;
}

export const TabGalleryImageComponent = (props: TabGalleryImageModalProps) => {
  const { onDismiss, theme, showGallery, galleryData } = props;
  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  const filteredImages = useMemo(() => {
    return getFilteredImages(galleryData, currentTabIndex);
  }, [galleryData, currentTabIndex]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    handleTabChangeWithScroll(event, newValue, setCurrentTabIndex);
  };

  return (
    <BaseModal open={showGallery} hideCloseButton onDismiss={onDismiss} bgColor={theme?.custom.colors.white}>
      <TabGalleryImageContainer data-testid={TestId.imageGallery.main}>
        <GalleryCloseButton onDismiss={onDismiss} />

        <GalleryTabs galleryData={galleryData} currentTabIndex={currentTabIndex} onTabChange={handleTabChange} />

        <GalleryImageGrid filteredImages={filteredImages} variant="tab" />
      </TabGalleryImageContainer>
    </BaseModal>
  );
};

export const TabGalleryImageModal = withTheme(TabGalleryImageComponent);
